import React, { useMemo } from 'react'
import { ResponsiveLine } from '@nivo/line'
import { normalizeCurrency } from '@/utils/normalize'
import { ChartTooltip, dashboardChartTheme, thinTicks } from '../charts/theme'

export const OperationGraphic: React.FC<{
  data: any[]
  /** Formata o eixo Y como moeda — o gráfico "por valor pago". */
  currency?: boolean
}> = ({ data, currency = false }) => {
  const getColor = bar => {
    return data.find(i => i.id === bar.id)?.color || '#222'
  }

  /* Enquanto o dado não chega a série vem vazia, e o nivo emite <path d="null">
     — oito erros de SVG no console a cada carregamento do dashboard. */
  const series = useMemo(
    () => data.filter(serie => serie?.data?.length),
    [data]
  )

  const tickValues = useMemo(() => thinTicks(series, 7), [series])

  if (!series.length) {
    return (
      <div className="dash-empty">
        <strong>Sem dados no período</strong>
      </div>
    )
  }

  return (
    <ResponsiveLine
      data={series}
      theme={dashboardChartTheme}
      margin={{
        top: 12,
        right: 16,
        bottom: 28,
        left: currency ? 62 : 38
      }}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false
      }}
      enableGridX={false}
      enableGridY
      gridYValues={4}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 9,
        ...(tickValues ? { tickValues } : {})
      }}
      axisLeft={{
        tickSize: 0,
        tickPadding: 8,
        tickValues: 4,
        format: (value: any) =>
          currency ? normalizeCurrency(value, true) : value
      }}
      curve="monotoneX"
      colors={getColor}
      useMesh={true}
      enablePoints={false}
      enableArea
      areaOpacity={0.12}
      enableCrosshair
      lineWidth={2}
      tooltip={data => {
        return (
          <ChartTooltip color={data.point.serieColor}>
            <strong>
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data.point.data.date
              }
            </strong>
            <br />
            Operações:{' '}
            <strong style={{ fontVariantNumeric: 'tabular-nums' }}>
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data.point.data.total
              }
            </strong>
            <br />
            Valor pago:{' '}
            <strong style={{ fontVariantNumeric: 'tabular-nums' }}>
              {normalizeCurrency(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                data.point.data.paid_value,
                true
              )}
            </strong>
          </ChartTooltip>
        )
      }}
    />
  )
}
